import { Component, OnInit, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-start-up',
  templateUrl: './start-up.component.html',
  styleUrls: ['./start-up.component.css']
})
export class StartUpComponent implements OnInit {
  onMobile: boolean;
  onMobilexs: boolean;
  onMobilesm: boolean;

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {

    if (window.innerWidth >= 320 && window.innerWidth <= 350) {
      this.onMobilexs = true;
      this.onMobile = false;
      this.onMobilesm = false;
    } else if (window.innerWidth > 350 && window.innerWidth <= 380) {
      this.onMobilexs = false;
      this.onMobile = true;
      this.onMobilesm = false;
    } else if (window.innerWidth > 380 && window.innerWidth <= 449) {
      this.onMobilexs = false;
      this.onMobile = false;
      this.onMobilesm = true;
    } else {
      this.onMobile = false;
      this.onMobilexs = false;
      this.onMobilesm = false;
    }
  }
  constructor(
    private matDialogRef: MatDialogRef<StartUpComponent>,
    private router: Router
    ) { }

  ngOnInit(): void {
    this.getScreenSize();
  }
  getStarted() {
    this.matDialogRef.close();
  }
  userGuide() {
    this.matDialogRef.close();
    this.router.navigateByUrl('/userguide', { replaceUrl: true });
  }
}
